export enum LocationsApiUrls {
    GetConfigurations='/api/Configuration/GetConfigurations',
    GetLocations ='/api/Location/GetLocations',
    CreateEditLocation ='/api/Location/CreateEditLocation',
    BindLocationWithJob ='/api/Location/BindLocationWithJob',
    DeleteLocation ='/api/Location/DeleteLocation',
    UnassignLocation ='/api/Location/UnassignLocation',
    UpdateLocations = '/api/Location/UpdateLocations',
    GetPlanAndJobsLocations = "/api/Location/GetPlanAndJobsLocations",
    GetLocationBySegmentId = "/api/Location/GetLocationBySegment",
    GetUnAssignedLocations = "/api/Location/GetUnAssignedLocations",
    GetDistinctPlanLocations = "/api/Location/GetDistinctPlanLocations",
    DeleteLocationFromJob = "/api/Location/DeleteLocationFromJob",
    GetLocationById = "/api/Location/GetLocationById",
    UpdatePlanLocation = '/api/Location/UpdateLocation',
    UpdateLocationsAndCalculateJobETA = '/api/Location/UpdateLocationsAndCalculateJobETA',
    UpdateLocationAgainstSegmentAndCalculateJobETA = '/api/Location/UpdateLocationsAndCalculateJobETAAgainstSegment',
    GetLocationsByPlanId = '/api/Location/GetLocationsByPlanId',
    ImportPlanLocationCsv = '/api/Location/ImportPlanLocationUsingCsvFile',
    DeleteAllUnAssignedLocation = "/api/Location/DeleteAllUnAssignedLocation",
    RemoveOrUnassignedLocations = "/api/Location/DeleteLocations",
    DeleteUnassignedLocations = "/api/Location/DeleteUnAssignedLocations",
    GetLocationsUpdate = "/api/Location/GetLocationsUpdate",
    UpdateLocationsFromMls = "/api/Location/UpdateLocationFromMLS",
    UpdateLocationDetails = "/api/Location/UpdateMultipleLocationDetails",
    GetMlsTags = '/api/Tag/GetTags',
    GetLookupLocations = "/api/Location/GetLookupLocations",
  }
